import React, { useState, useEffect } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, NavLink } from 'react-router-dom';
import { Container, NavDropdown } from 'react-bootstrap';
import './Header.css';
import logo from '../../Assets/Images/logo.png';

const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const [scrollHeight, setScrollHeight] = useState(0);

  const normalLink = 'text-gray-400 ';
  const activeLink = 'active text-gray-400';

  useEffect(() => {
    const handleScroll = () => {
      setScrollHeight(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Navbar
      expanded={expanded}
      sticky='top'
      expand="lg"
      className={`my-nav py-0 px-2 text-sm ${scrollHeight >= 80 ? 'bg-textColor-200 ' : 'bg-transparent text-textColor-100'}`}
      style={{ transition: 'background-color 0.3s ease-in-out' }}
    >
      <Container className='px-2 py-1 md:px-10'>
        <Navbar.Brand className='text-white'>
          <Link to='/'><img className="w-16 h-16 object-contain" src={logo} alt="brand" /></Link>
        </Navbar.Brand>
        <Navbar.Toggle
          onClick={() => setExpanded(expanded ? false : 'expanded')}
          aria-controls="responsive-navbar-nav"
          className='d-flex d-lg-none flex-column justify-content-around'
        >
          <span className='toggler-icon top-bar'></span>
          <span className='toggler-icon mid-bar'></span>
          <span className='toggler-icon bottom-bar'></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="d-flex ms-auto font-semibold justify-content-around align-items-md-center gap-2 lg:gap-4">
          <div className='pt-2'></div>
            <NavLink
              onClick={() => setExpanded(false)}
              className={({ isActive }) => (isActive ? `${activeLink}` : `${scrollHeight >= 80 ? 'text-gray-800' : normalLink} nav-item text-sm text-gray-800 `)}
              to="/"
            >
              Home
            </NavLink>
            
            <NavDropdown

              title={<span className={scrollHeight >= 80 ? '' : `${normalLink} nav-item text-sm`}>Company</span>}
              id="collapsible-nav-dropdown"
              >
  <NavDropdown.Item>
    <NavLink onClick={() => setExpanded(false)} to="/company/about">About Us</NavLink>
  </NavDropdown.Item>
  <NavDropdown.Item>
    <NavLink onClick={() => setExpanded(false)} to="/Company/vision-mission">Vision & Mission</NavLink>
  </NavDropdown.Item>
  <NavDropdown.Item>
    <NavLink onClick={() => setExpanded(false)} to="/company/team">Our Team</NavLink>
  </NavDropdown.Item>
</NavDropdown>

            <NavLink
              onClick={() => setExpanded(false)}
              className={({ isActive }) => (isActive ? `${activeLink}` : `${scrollHeight >= 80 ? 'text-white' : normalLink} nav-item text-sm`)}
              to="/products"
            >
              Products
            </NavLink>
            <NavLink
              onClick={() => setExpanded(false)}
              className={({ isActive }) => (isActive ? `${activeLink}` : `${scrollHeight >= 80 ? 'text-gray-800' : normalLink} nav-item text-sm`)}
              to="/contact-us"
            >
              Contact Us
            </NavLink>
            <div className="pb-2"></div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
